import { createIsomorphicFn } from '@tanstack/react-start';
import { serverRuntime, ssrApiTransportOptions } from './server-runtime.server';
import { clientRuntime } from './client-runtime';
import type { ApiTransportOptions } from '@listening/api-contract/api-client-tag';

export const getRuntime = createIsomorphicFn()
  .server(() => serverRuntime)
  .client(() => clientRuntime);

/** Where `getRuntime()`'s API requests go, for the registry's API atoms. The
 * browser's go to its own origin. */
export const getApiTransportOptions = createIsomorphicFn()
  .server(() => ssrApiTransportOptions)
  .client((): ApiTransportOptions => ({}));
